<div *ngIf="config">
    <!-- <span align="center">{{data.mqtt.subscribeTopic}}</span>
    <br /> -->
    <div *ngIf="trace$ | async as trace">
        <plotly-plot [data]="[trace]" [layout]="layout" [config]="config">
        </plotly-plot>
    </div>
</div>